import { Box, Icon, Typography, useTheme } from '@mui/material';
import { ReadonlyCoverageCheckbox as ReadonlyCoverageCheckboxSchema } from '@/schemas/sceneDataSchema';
import { useCoverageAttribute } from '@/hooks/use-quote';
import { roundCurrencyAmountsInText } from '@/utils/roundCurrencyAmountsInText';

export const ReadonlyCoverageCheckboxFormElement = ({ component }: { component: ReadonlyCoverageCheckboxSchema }) => {
  const theme = useTheme();
  const { options, findSelectedIndex } = useCoverageAttribute({
    symbol: component.symbol,
    scope: component.scope,
    kind: component.kind,
  });

  const selectedIndex = findSelectedIndex();
  // First option = checked/included, anything else = unchecked/not included
  const isChecked = selectedIndex === 0;
  const selectedOption = selectedIndex >= 0 ? options[selectedIndex] : null;
  const labelText = selectedOption?.label
    ? roundCurrencyAmountsInText(selectedOption.label)
    : isChecked
      ? 'Included'
      : 'Not included';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        padding: 1,
        borderRadius: 1,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Icon
        sx={{
          fontFamily: 'Material Symbols Outlined',
          color: isChecked ? theme.palette.success.main : theme.palette.text.secondary,
        }}
        fontSize='small'
      >
        {isChecked ? 'check' : 'close'}
      </Icon>
      <Typography
        variant='body1'
        color={isChecked ? 'text.primary' : 'text.secondary'}
      >
        {labelText}
      </Typography>
    </Box>
  );
};
